import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/common/Button";
import { ROUTES } from "../../routes";
import styles from "./LoginScreen.module.css";

/** Shown when B2C sign-in succeeds but the API 403s every request -- the
 * account isn't a member of the B2C admin group (api/services/auth.py's
 * _is_admin). Distinct from a login failure: the person IS who they say
 * they are, they just don't have admin access (yet). */
export function ForbiddenPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.logo} aria-hidden="true">🔒</div>
        <h1>No Admin Access</h1>
        <p>
          You're signed in, but your account isn't a member of the admin group yet. If you need access, request it
          below -- a second admin must approve before you can use this console.
        </p>
        <div style={{ display: "flex", gap: "var(--space-2)", justifyContent: "center", marginTop: "var(--space-4)" }}>
          <Button onClick={() => navigate(ROUTES.ACCESS_REQUEST)}>Request Admin Access</Button>
          <Button variant="secondary" onClick={logout}>Sign Out</Button>
        </div>
      </div>
    </div>
  );
}
